export default function adjustInfoVertical(element, bis, first) {

  //get #binfo ////////////////////////////
  if (first == true) {
    //console.log("je passe ici")
    if (bis == true) {
      var binfo = element.select('#binfobis');
    } else {
      var binfo = element.select('#binfo');
    }
    var bindic = element.select('#bindic');

  } else {
    //console.log("je passe la")
    //var bindic = element.parent().parent().parent().parent().select('#bindic');
    if (bis == true) {
      var binfo = element.select('#binfobis');
      if (binfo == null) {
        binfo = element.parent().select('#binfobis');
      }
      if (binfo == null) {
        binfo = element.parent().parent().select('#binfobis');
      }
      if (binfo == null) {
        binfo = element.parent().parent().parent().select('#binfobis');
      }
      if (binfo == null) {
        binfo = element.parent().parent().parent().parent().select('#binfobis');
      }
    } else {
      var binfo = element.select('#binfo');
      if (binfo == null) {
        binfo = element.parent().select('#binfo');
      }
      if (binfo == null) {
        binfo = element.parent().parent().select('#binfo');
      }
      if (binfo == null) {
        binfo = element.parent().parent().parent().select('#binfo');
      }
      if (binfo == null) {
        binfo = element.parent().parent().parent().parent().select('#binfo');
      }
    }
  }



 // if (binfo != null && bindic == null) {
  if (binfo != null) {
    //console.log("binfo"+bis+" ok");
    // #binfo's zone informations (rect) ////////////////////////////
    const binfoID = binfo.node.id;
    const leRect = binfo.parent().select('#' + binfoID + ' > rect');
    const rectHeight = leRect ? leRect.getBBox().h : 0
    const rectY = leRect ? leRect.getBBox().y : 0
    const rectX = leRect ? leRect.getBBox().x : 0

    //select all text in binfo ////////////////////////////

    const Tempelements = binfo.selectAll('text');

    //get all text elements in binfo ////////////////////////////

    var items = [];
    Tempelements.forEach((tempElement) => {
      if (tempElement.attr('visibility') != 'hidden') {
        items.push({
          object: tempElement,
          rect: tempElement.parent().select('rect').attr('y'),
          id: tempElement.parent().parent().node.id,
          y: Math.round(tempElement.getBBox().y),
          h: Math.round(tempElement.getBBox().h),
          pos: tempElement.attr('base-pos') ? tempElement.attr('base-pos') : ''
        });
      }
    })

    //sort element by y position ////////////////////////////
    if (items[0].object.attr('base-pos') === null) {
      items.sort(function (a, b) {
        return a.y - b.y;
      });
    } else {
      items.sort(function (a, b) {
        return a.pos - b.pos;
      });
    }
    //console.log(items)
    //line height ratio by font (not so elegant but... what do you want ? ^^) ////////////////////////////
    const style = getComputedStyle(items[0].object.node);
    const font = style.getPropertyValue('font-family');
    const fontName = font.slice(0, 4)
    var ratio = 1;

    switch (fontName) {
      case 'Goth':
        ratio = 1.4;
        break;
      case 'Helv':
        ratio = 1.39;
        break;
      case 'Swis':
        ratio = 1.65;
        break;
      case 'Typo':
        ratio = 1.93;
        break;
      case 'Fira':
        ratio = 1.7;
        break;
        case 'DIN-':
        ratio = 2.5;
        break;
      default:
        ratio = 1.3;
    }


    // transform transform() in x and y 
    for (var j = 0; j < items.length; j++) {
      //console.log(items[j].id);
      if (items[j].object.attr('base-pos') === null) {
        items[j].object.attr('base-pos', (j + 1));
      }
      if (items[j].object.attr('y') === null) {
        items[j].object.attr('y', Math.round(items[j].object.transform().localMatrix.split().dy))
      }
      if (items[j].object.attr('x') === null) {
        items[j].object.attr('x', Math.round(items[j].object.transform().localMatrix.split().dx));
      }
      items[j].object.node.removeAttribute('transform');
    }

    //



    // base marging between the 2 first elements ////////////////////////////
    if (items[0].object.attr('si:marging') === null) {
      const marg1 = Math.round(parseFloat(items[1].rect) - (parseFloat(items[0].rect) + Math.round(items[0].h / ratio)));
      const marg2 = items[2] ? Math.round(parseFloat(items[2].rect) - (parseFloat(items[1].rect) + Math.round(items[1].h / ratio))) : marg1


      if (items[3] == null) {
        items[0].object.attr('si:marging', (marg1 + marg2) / 2)
      } else {
        const marg3 = Math.round(parseFloat(items[3].rect) - (parseFloat(items[2].rect) + Math.round(items[2].h / ratio)))
        items[0].object.attr('si:marging', (marg1 + marg2 + marg3) / 3)
      }

      // 
    }
    const marg = parseFloat(items[0].object.attr('si:marging'))

    for (var k = 1; k < items.length; k++) {
      if (items[k].object.attr('si:marging') === null) {
        items[k].object.attr('si:marging', marg)
      }
    }

    var allTextHeight = 0;
    for (var j = 0; j < items.length; j++) {
      allTextHeight += Math.round(items[j].h / ratio) + marg;
    }
    allTextHeight -= marg;

    // difference between all text height and binfo zone ////////////////////////////

    var diff = Math.round(rectHeight - allTextHeight);

    //first element position ////////////////////////////

    items[0].object.attr('y', (rectY + (diff / 2) + Math.round(items[0].h / ratio)))

    //next element position ////////////////////////////

    for (var i = 1; i < items.length; i++) {
      items[i].object.attr('y', parseFloat(items[i - 1].object.attr('y')) + ((items[i].h / ratio) + marg))
    }
  }else{
    //console.log('no binfo')
  }
}
